module.exports = __webpack_public_path__ + "img/화장품.5c9f24b6.png";